import { Component, ViewEncapsulation, input } from '@angular/core';

import { EmailCodeBoxComponent } from '../../components/email-codebox/email-codebox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-verification-code-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './verification-code.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailCodeBoxComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class VerificationCodeTemplateComponent {
  public readonly data = input.required<WrappedValue<VerificationCodeTemplateData>>();
}

export type VerificationCodeTemplateData = {
  title: string;
  avatar_url: string;
  p1: string;
  code: string;
  p2: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const VerificationCodeTemplateMocks: VerificationCodeTemplateData[] = [
  {
    title: 'Verification code',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    p1: 'Enter this verification code to continue setting up your Recruitee account.',
    code: '232564',
    p2: 'This email contains private information for your Recruitee account. Please don’t forward it or share it any other way.',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
